import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=f5103d1e&scoped=true&lang=pug"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5103d1e",
  null
  
)

export default component.exports